export default __webpack_public_path__ + "static/media/defient_visual-blimp.png";